import styled from 'styled-components';
import { container, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledCompanies = styled.div`
  margin-top: -${spacing('xl4')};
`;

export const StyledHeroImage = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: absolute;
  top: ${spacing('xl6')};
  pointer-events: none;

  @media (min-width: ${container('lg')}) {
    display: flex;
  }

  .stars {
    position: absolute;
    top: -${spacing('xl6')};
    left: 0;
    width: 100%;
  }

  .ship {
    object-fit: contain;
    max-height: 6rem;
    margin-left: 1rem;
    margin-bottom: 7rem;
    transform: translateY(0);
    animation: float-far 8s ease-in-out infinite;

    @media (min-width: ${screen('xl')}) {
      margin-left: 10vw;
      max-height: 14rem;
      margin-bottom: 2rem;
    }
  }

  .astronaut {
    object-fit: contain;
    max-height: 21rem;
    margin-left: -5rem;
    transform: translateY(0);
    margin-top: -2rem;
    animation: float 6s ease-in-out infinite;

    @media (min-width: ${screen('xl')}) {
      margin-left: -2rem;
      max-height: 40rem;
      margin-top: -10rem;
    }
  }

  @keyframes float-far {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(0);
    }
  }

  @keyframes float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(0);
    }
  }
`;

export const StyledHeroWrapper = styled.div`
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    #0a0227 0%,
    #0a0328 8.07%,
    #0a072c 15.54%,
    #0b0d32 22.5%,
    #0c153a 29.04%,
    #0d1f43 35.26%,
    #0e294d 41.25%,
    #0f3457 47.1%,
    #0f3e62 52.9%,
    #10496c 58.75%,
    #115376 64.74%,
    #125d7f 70.96%,
    #136587 77.5%,
    #146b8d 84.46%,
    #146f91 91.93%,
    #147092 100%
  );

  &::after {
    background-image: ${() =>
      `url('${getPublicPath('/images/companies/curve.svg')}')`};
    content: '';
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    display: block;
    width: 100%;
    height: 8rem;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &.companiesForm {
    padding-top: ${spacing('xl3')};

    ${StyledHeroImage} {
      height: 100%;

      .astronaut {
        max-height: 40rem;
        margin-left: -1rem;
      }
    }
  }
`;
